import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Card, StatusBadge, fmtDate, inputCls } from "@/components/common/Form";
import { EmptyState, LoadingState } from "@/components/common/States";
import { RfqItems, QuoteCard, RfqMeta } from "@/pages/business/RfqPages";

const STATUSES = ["", "SUBMITTED", "VIEWED", "QUOTED", "ACCEPTED", "REJECTED", "EXPIRED"];

export default function AdminRfqs() {
  const [data, setData] = useState(null);
  const [filters, setFilters] = useState({ q: "", vendor: "", business_user_id: "", status: "" });
  const [open, setOpen] = useState(null);
  useEffect(() => {
    let c = false;
    const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v));
    api.get("/admin/rfqs", { params }).then((r) => { if (!c) setData(r.data); }).catch((e) => { if (!c) { setData({ items: [], total: 0 }); toast.error(formatApiError(e.response?.data?.detail)); } });
    return () => { c = true; };
  }, [filters]);
  const view = async (id) => {
    try { setOpen((await api.get(`/admin/rfqs/${id}`)).data); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const set = (k) => (e) => setFilters({ ...filters, [k]: e.target.value });
  return (
    <div className="space-y-6" data-testid="admin-rfqs-page">
      <Card title="Wholesale RFQs" subtitle={data ? `${data.total} request(s)` : ""} testId="admin-rfqs-card">
        <div className="grid sm:grid-cols-4 gap-3 mb-4">
          <input data-testid="admin-rfq-search" placeholder="Search RFQ no. / buyer / vendor" value={filters.q} onChange={set("q")} className={inputCls} />
          <input data-testid="admin-rfq-vendor" placeholder="Vendor slug" value={filters.vendor} onChange={set("vendor")} className={inputCls} />
          <input data-testid="admin-rfq-buyer" placeholder="Business user id" value={filters.business_user_id} onChange={set("business_user_id")} className={inputCls} />
          <select data-testid="admin-rfq-status" value={filters.status} onChange={set("status")} className={inputCls}>{STATUSES.map((s) => <option key={s} value={s}>{s || "All statuses"}</option>)}</select>
        </div>
        {!data ? <LoadingState /> : data.items.length === 0 ? <EmptyState title="No RFQs found" /> : (
          <div className="overflow-x-auto"><table className="w-full text-sm" data-testid="admin-rfq-table">
            <thead><tr className="text-left text-xs text-stone-500 border-b border-border"><th className="py-2 pr-3">RFQ</th><th className="py-2 pr-3">Buyer</th><th className="py-2 pr-3">Vendor</th><th className="py-2 pr-3">Units</th><th className="py-2 pr-3">Status</th><th className="py-2 pr-3">Date</th><th /></tr></thead>
            <tbody>{data.items.map((r) => (
              <tr key={r.id} className="border-b border-border/60" data-testid={`admin-rfq-row-${r.rfq_number}`}>
                <td className="py-2 pr-3 font-semibold text-stone-900">{r.rfq_number}</td><td className="py-2 pr-3">{r.business_name}</td><td className="py-2 pr-3">{r.vendor_name}</td>
                <td className="py-2 pr-3">{r.item_count}</td><td className="py-2 pr-3"><StatusBadge value={r.status} /></td><td className="py-2 pr-3 text-stone-500">{fmtDate(r.created_at)}</td>
                <td className="py-2"><button data-testid={`admin-rfq-view-${r.rfq_number}`} onClick={() => view(r.id)} className="text-xs font-semibold text-secondary">View</button></td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </Card>
      {open && (
        <Card title={open.rfq_number} subtitle={`Status: ${open.status}`} testId="admin-rfq-detail" action={<button onClick={() => setOpen(null)} className="text-sm text-stone-500">Close</button>}>
          <div className="grid lg:grid-cols-[1fr_320px] gap-4">
            <div className="space-y-3"><RfqItems rfq={open} />{open.quotes.map((q) => <QuoteCard key={q.id} quote={q} />)}</div>
            <RfqMeta rfq={open} vendorView />
          </div>
        </Card>
      )}
    </div>
  );
}
